import Link from "next/link";
import styles from "./featureCard.module.scss";
import { getCmsIcon } from "@kunduz/utility-common";
import { ChevronRight } from "@untitled-ui/icons-react";
import { CSSProperties } from "react";

export const FeatureCard = (props: FeatureCardProps) => {
  const {
    title,
    description,
    urlText,
    url,
    badgeIcon,
    badgeIconUrl,
    backgroundColor,
    style,
  } = props;

  const BadgeIcon = getCmsIcon(badgeIcon);

  return (
    <div
      className={styles.container}
      style={{ ...style, backgroundColor: backgroundColor }}
    >
      {badgeIcon && <BadgeIcon width={48} height={48} />}
      {badgeIconUrl && (
        <img src={badgeIconUrl} alt={title} width={48} height={48} />
      )}
      {title && <div className={styles.title}>{title}</div>}
      {description && <div className={styles.description}>{description}</div>}
      {(urlText || url) && (
        <Link href={url} className={styles.url}>
          {urlText} <ChevronRight width={24} height={24} />
        </Link>
      )}
    </div>
  );
};

export interface FeatureCardProps {
  title: string;
  description: string;
  urlText: string;
  url: string;
  badgeIcon?: string;
  badgeIconUrl?: string;
  backgroundColor?: string;
  style?: CSSProperties;
}
